<template>
  <a-layout-content style="margin: 16px">
    <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0' }"
        v-on:click="showModal"
      >
        新增
      </a-button>
      <a-modal
        v-model="visible"
        title="添加分类"
        @ok="handleOk"
        cancelText="取消"
        okText="确定"
      >
        <a-form-model
          :model="formInline"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <a-form-model-item label="分类名称">
            <a-input
              v-model="formInline.categoryName"
              placeholder="请输入分类名称"
            >
            </a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        v-model="visibletwo"
        title="添加分类"
        @ok="handleOktwo"
        cancelText="取消"
        okText="确定"
      >
        <a-form-model
          :model="formInline"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <a-form-model-item label="分类名称">
            <a-input
              v-model="formInlinetwo.categoryNametwo"
              placeholder="请输入分类名称"
            >
            </a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :row-key="(item) => item.categoryName"
        @change="handleTableChange"
        size="middle"
      >
        <!-- <template slot="categoryName" slot-scope="categoryName">
          {{ categoryName }} 
        </template>
         <template slot="categoryName" slot-scope="categoryName">
          {{ categoryName }} 
        </template> -->
        <template slot="operate" slot-scope="text, operate">
          <a href="javascript:;" @click="editbtn(operate)">编辑</a>
          <a href="javascript:;" @click="delbtn(operate)">删除</a>
        </template>
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>
import {
  storeClassification,
  storeClassificationEdit,
  storeClassificationAdd,
  storeClassificationDel,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "项目名称",
    dataIndex: "projectName",
    sorter: true,
    scopedSlots: { customRender: "projectName" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      updateId: null,
      formInline: {
        categoryName: "", // 输入的分类名称
        sortNum: "", // 输入的显示数据
      },
      formInlinetwo: {
        categoryNametwo: "", // 输入的分类名称
        sortNumtwo: "", // 输入的显示数据
      },
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      visible: false,
      visibletwo: false,
    };
  },
  mounted() {
    this.getStoreClassification();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeClassification({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
      this.loading = false;
    },
    getStoreClassification() {
      storeClassification({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    // 删除
    delbtn(row) {
      this.loading = true;
      storeClassificationDel(row.objId).then((res) => {
        this.loading = false;
        this.getStoreClassification();
        message.success(res.data);
      });
    },
    // 编辑
    editbtn(row) {
      console.log(row);
      this.updateId = row.objId;
      this.visibletwo = true;
      this.formInlinetwo.categoryNametwo = row.projectName;
    },
    handleSubmit() {},
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      // 添加
      storeClassificationAdd({
        projectName: this.formInline.categoryName,
      }).then((res) => {
        this.getStoreClassification();
        message.success(res.data);
      });
      this.formInline = {
        categoryName: "", // 输入的分类名称
        sortNum: "", // 输入的显示数据
      };
      this.visible = false;
    },
    handleOktwo() {
      storeClassificationEdit({
        projectName: this.formInlinetwo.categoryNametwo,
        id: this.updateId,
      }).then((res) => {
        this.getStoreClassification();
        message.success(res.data);
      });
      this.formInlinetwo = {
        categoryNametwo: "", // 输入的分类名称
      };
      this.visibletwo = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/storeManagement/storeClassificationTwo/storeClassificationTwo.vue